import Vue from 'vue';
import resetState from '@/helpers/resetState';
import store from '@/store';
import { ABI } from './ABI';
import { formatData } from '@/constants/commonContent';
import { messages } from '@/constants/messages';
import { Contract } from 'web3-eth-contract';

const FEATURE_NAME = 'FinancialStatementFeature';

let from;

async function contract(): Promise<Contract> {
  from = {from: store.getters.getWallet};
  const address = store.getters.getFeatureAddress(FEATURE_NAME);
  return new Promise(resolve => {
    let contract = new window.web3.eth.Contract(ABI, address);
    resolve(contract);
  });
}

const initialState = {
  finStatements: {},
  finStatementCounter: 0
};

const state = {
  finStatements: initialState.finStatements,
  finStatementCounter: initialState.finStatementCounter
};

const getters = {
  getFinStatementCounter: state => state.finStatementCounter,
  getFinStatements: state => state.finStatements,
  getFinStatement: state => id => state.finStatements[id]
};

const mutations = {
  resetFinancialStatementFeature: state => {
    resetState(state, initialState);
  },
  setFinStatementCounter: (state, item) => {
    state.finStatementCounter = item;
  },
  setFinStatement: (state, item) => {
    Vue.set(state.finStatements, item.id, item);
  }
};

const actions = {
  initFinancialStatementFeature({ dispatch, commit }) {
    dispatch('getFinStatementsDapp');
    //Events
    contract().then(contract => {
      contract.events.FinancialStatementEvent().subscribe((err) => {
        if (!err) {
          dispatch('getFinStatementsDapp');
        }
        commit('finStatementPending', false);
        commit('resetMailPending', 'uploadFile');
      });
    });
  },
  /**
   * Get FinStatement counter
   * @return {Promise<number>}
   * @res[0] "counter" {number}
   */
  getFinStatementCounterDapp({ commit }) {
    return new Promise(resolve => {
      contract().then(contract => {
        contract.methods.getFinStatementCounter()
          .call(from)
          .then(res => {
            commit('setFinStatementCounter', parseInt(res));
            resolve(parseInt(res));
          })
          .catch(console.error);
      });
    });
  },
  /**
   * Get FinStatement
   * @param id {number}
   * @res[0] "address creator" {string}
   * @res[1] "title" {string}
   * @res[2] "name" {string}
   * @res[3] "file" {string}
   * @res[4] "time" {number}
   */
  getFinStatementDapp({ commit }, id) {
    contract().then(contract => {
      contract.methods.getFinStatement(id)
        .call()
        .then(res => {
          commit('setFinStatement', {
            id,
            address: res[0],
            title: res[1],
            name: res[2],
            fileHash: res[3],
            creationTime: parseInt(res[4])
          });
        })
        .catch(console.error);
    });
  },
  getFinStatementsDapp({ dispatch }) {
    dispatch('getFinStatementCounterDapp').then(result => {
      for (var i = 0; i < result; i++) {
        dispatch('getFinStatementDapp', i);
      }
    });
  },
  /**
   * Add FinStatement
   * @param data.title {string}
   * @param data.name {string}
   */
  addFinStatementDapp({ commit, dispatch }, data) {
    contract().then(contract => {
      contract.methods.addFinStatement(data.title, data.name, data.file)
        .send(from, (err, res) => {
          if (err) {
            commit('finStatementPending', false);
            Vue.toasted.error(messages.canceled);
          } else {
            dispatch('sendUploadFileMailExt', {
              title: data.title,
              time: Vue.moment().format(formatData.dateTime),
              tx: res
            });
          }
        });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
